
    // this file was auto generated by python script
    import Watch from './Watch';
    export default Watch;
    